import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Glyph from 'kepler/lib/components/Glyph';

class TopicList extends PureComponent {
  static parserLabels(labels) {
    return labels.replace(/,/g, ', ');
  }

  // Handle each Topic item click event
  handleClick(content) {
    this.props.onClick({ content, layer: this.props.layer });
  }

  topicLabel(topicName) {
    const label = this.props.labels[topicName] || [];
    if (label.length > 0) {
      return (
        <div className="item-label">{TopicList.parserLabels(label.toString())}</div>
      );
    }
    return null;
  }

  renderListContent(content) {
    return (
      <div className="topic-list-content" key={content.topic_id}>
        <div // eslint-disable-line jsx-a11y/no-static-element-interactions
          className="topic-item"
          role="button"
          tabIndex="0"
          onClick={() => this.handleClick(content)}
        >
          <div className="item-container">
            <div className="item-heading">{content.topic_name}</div>
            {this.topicLabel(content.topic_name)}
          </div>
          <Glyph icon="icon-arrow-right-small" className="accordion-icon" />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.topicList.map(content => this.renderListContent(content))}
      </div>
    );
  }
}

TopicList.propTypes = {
  topicList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  layer: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
  labels: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

TopicList.defaultProps = {
  topicList: [],
  layer: 1,
  onClick: () => {},
  className: 'topics-list-container',
  labels: {},
};

export default TopicList;
